import { render, staticRenderFns } from "./CriticalChainContainer.vue?vue&type=template&id=2e5b1b9d&"
import script from "./CriticalChainContainer.vue?vue&type=script&lang=js&"
export * from "./CriticalChainContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports